export default {
  SET_HUB_ANALYTICS_CONFIGURATIONS(state, { type, payload }) {
    state.hubAnalyticsConfigurations[type] = payload
  },
  SET_HUB_ANALYTICS_LIMITS(state, payload) {
    state.hubAnalyticsLimits = payload
  },
  SET_LOADING_REPORTS_LIST(state, payload) {
    state.loadingReportsList = payload
  },
  SET_ENTITIES_LINKED_BY_HUB_CONFIGURATION(state, payload) {
    state.entitiesLinkedByHubConfiguration = payload
  },
}
